export const getWeekdayLabels = (
  locale: string,
  format: 'long' | 'short' | 'narrow' = 'long',
) => {
  const weekdays = []
  // Start with Monday (1) through Sunday (0)
  // JavaScript getDay() returns 0 for Sunday, 1 for Monday, etc.
  const daysOrder = [1, 2, 3, 4, 5, 6, 0]

  const formatter = new Intl.DateTimeFormat(locale, { weekday: format })

  // Create a date object for the first day of a week
  // The exact date doesn't matter as long as we can get all 7 days
  const baseDate = new Date(2023, 0, 1) // January 1st, 2023

  // Set the date to a Sunday (0)
  baseDate.setDate(baseDate.getDate() + (0 - baseDate.getDay()))

  // Get all weekday names in the right order (starting with Monday)
  for (const dayIndex of daysOrder) {
    baseDate.setDate(baseDate.getDate() + (dayIndex - baseDate.getDay()))
    weekdays.push(formatter.format(baseDate))
  }

  return weekdays
}

// For backward compatibility
export const weekdayLabels = getWeekdayLabels('en')
